/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CreateWorkingTimeBooking,
  CreateWorkingTimeBookingResponse,
  CreateWorkingTimeCorrectionRequest,
  DailyWorkingTimeBookings,
  GetPagedWorkingTimeBookingsRequest,
  UpdateWorkingTimeBookingStatusRequest,
  WorkingTimeBookingDtoPagination,
  WorkingTimeBookingTypeDto
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getGetWorkingTimeBookingsUrl = () => {


  

  return `/api/WorkingTimeBooking/GetWorkingTimeBookings`
}

export const getWorkingTimeBookings = async ( options?: RequestInit): Promise<DailyWorkingTimeBookings[]> => {
  
  return customInstance<DailyWorkingTimeBookings[]>(getGetWorkingTimeBookingsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetWorkingTimeBookingsQueryKey = () => {
    return [
    `/api/WorkingTimeBooking/GetWorkingTimeBookings`
    ] as const;
    }

    
export const getGetWorkingTimeBookingsQueryOptions = <TData = Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkingTimeBookingsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkingTimeBookings>>> = ({ signal }) => getWorkingTimeBookings({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetWorkingTimeBookingsQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkingTimeBookings>>>
export type GetWorkingTimeBookingsQueryError = ErrorType<unknown>


export function useGetWorkingTimeBookings<TData = Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkingTimeBookings>>,
          TError,
          Awaited<ReturnType<typeof getWorkingTimeBookings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWorkingTimeBookings<TData = Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkingTimeBookings>>,
          TError,
          Awaited<ReturnType<typeof getWorkingTimeBookings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWorkingTimeBookings<TData = Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetWorkingTimeBookings<TData = Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetWorkingTimeBookingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetWorkingTimeBookingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkingTimeBookingsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkingTimeBookings>>> = ({ signal }) => getWorkingTimeBookings({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetWorkingTimeBookingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkingTimeBookings>>>
export type GetWorkingTimeBookingsSuspenseQueryError = ErrorType<unknown>


export function useGetWorkingTimeBookingsSuspense<TData = Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWorkingTimeBookingsSuspense<TData = Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWorkingTimeBookingsSuspense<TData = Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetWorkingTimeBookingsSuspense<TData = Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetWorkingTimeBookingsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCreateWorkingTimeBookingUrl = () => {


  

  return `/api/WorkingTimeBooking/CreateWorkingTimeBooking`
}

export const createWorkingTimeBooking = async (createWorkingTimeBooking: CreateWorkingTimeBooking, options?: RequestInit): Promise<CreateWorkingTimeBookingResponse> => {
  
  return customInstance<CreateWorkingTimeBookingResponse>(getCreateWorkingTimeBookingUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createWorkingTimeBooking,)
  }
);}




export const getCreateWorkingTimeBookingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorkingTimeBooking>>, TError,{data: BodyType<CreateWorkingTimeBooking>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createWorkingTimeBooking>>, TError,{data: BodyType<CreateWorkingTimeBooking>}, TContext> => {

const mutationKey = ['createWorkingTimeBooking'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWorkingTimeBooking>>, {data: BodyType<CreateWorkingTimeBooking>}> = (props) => {
          const {data} = props ?? {};

          return  createWorkingTimeBooking(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateWorkingTimeBookingMutationResult = NonNullable<Awaited<ReturnType<typeof createWorkingTimeBooking>>>
    export type CreateWorkingTimeBookingMutationBody = BodyType<CreateWorkingTimeBooking>
    export type CreateWorkingTimeBookingMutationError = ErrorType<unknown>

    export const useCreateWorkingTimeBooking = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorkingTimeBooking>>, TError,{data: BodyType<CreateWorkingTimeBooking>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createWorkingTimeBooking>>,
        TError,
        {data: BodyType<CreateWorkingTimeBooking>},
        TContext
      > => {

      const mutationOptions = getCreateWorkingTimeBookingMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getGetWorkingTimeBookingTypesUrl = () => {


  

  return `/api/WorkingTimeBooking/GetWorkingTimeBookingTypes`
}

export const getWorkingTimeBookingTypes = async ( options?: RequestInit): Promise<WorkingTimeBookingTypeDto[]> => {
  
  return customInstance<WorkingTimeBookingTypeDto[]>(getGetWorkingTimeBookingTypesUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetWorkingTimeBookingTypesQueryKey = () => {
    return [
    `/api/WorkingTimeBooking/GetWorkingTimeBookingTypes`
    ] as const;
    }

    
export const getGetWorkingTimeBookingTypesQueryOptions = <TData = Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkingTimeBookingTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>> = ({ signal }) => getWorkingTimeBookingTypes({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetWorkingTimeBookingTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>>
export type GetWorkingTimeBookingTypesQueryError = ErrorType<unknown>


export function useGetWorkingTimeBookingTypes<TData = Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>,
          TError,
          Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWorkingTimeBookingTypes<TData = Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>,
          TError,
          Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWorkingTimeBookingTypes<TData = Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetWorkingTimeBookingTypes<TData = Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetWorkingTimeBookingTypesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetWorkingTimeBookingTypesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkingTimeBookingTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>> = ({ signal }) => getWorkingTimeBookingTypes({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetWorkingTimeBookingTypesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>>
export type GetWorkingTimeBookingTypesSuspenseQueryError = ErrorType<unknown>


export function useGetWorkingTimeBookingTypesSuspense<TData = Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWorkingTimeBookingTypesSuspense<TData = Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWorkingTimeBookingTypesSuspense<TData = Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetWorkingTimeBookingTypesSuspense<TData = Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkingTimeBookingTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetWorkingTimeBookingTypesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getDeleteWorkingTimeBookingsByIdsUrl = () => {


  

  return `/api/WorkingTimeBooking/DeleteWorkingTimeBookingsByIds`
}

export const deleteWorkingTimeBookingsByIds = async (deleteWorkingTimeBookingsByIdsBody: number[], options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getDeleteWorkingTimeBookingsByIdsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deleteWorkingTimeBookingsByIdsBody,)
  }
);}




export const getDeleteWorkingTimeBookingsByIdsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkingTimeBookingsByIds>>, TError,{data: BodyType<number[]>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteWorkingTimeBookingsByIds>>, TError,{data: BodyType<number[]>}, TContext> => {

const mutationKey = ['deleteWorkingTimeBookingsByIds'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWorkingTimeBookingsByIds>>, {data: BodyType<number[]>}> = (props) => {
          const {data} = props ?? {};

          return  deleteWorkingTimeBookingsByIds(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteWorkingTimeBookingsByIdsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWorkingTimeBookingsByIds>>>
    export type DeleteWorkingTimeBookingsByIdsMutationBody = BodyType<number[]>
    export type DeleteWorkingTimeBookingsByIdsMutationError = ErrorType<unknown>

    export const useDeleteWorkingTimeBookingsByIds = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkingTimeBookingsByIds>>, TError,{data: BodyType<number[]>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteWorkingTimeBookingsByIds>>,
        TError,
        {data: BodyType<number[]>},
        TContext
      > => {

      const mutationOptions = getDeleteWorkingTimeBookingsByIdsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getGetPagedWorkingTimeBookingsUrl = () => {


  

  return `/api/WorkingTimeBooking/GetPagedWorkingTimeBookings`
}

export const getPagedWorkingTimeBookings = async (getPagedWorkingTimeBookingsRequest: GetPagedWorkingTimeBookingsRequest, options?: RequestInit): Promise<WorkingTimeBookingDtoPagination> => {
  
  return customInstance<WorkingTimeBookingDtoPagination>(getGetPagedWorkingTimeBookingsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      getPagedWorkingTimeBookingsRequest,)
  }
);}




export const getGetPagedWorkingTimeBookingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPagedWorkingTimeBookings>>, TError,{data: BodyType<GetPagedWorkingTimeBookingsRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof getPagedWorkingTimeBookings>>, TError,{data: BodyType<GetPagedWorkingTimeBookingsRequest>}, TContext> => {

const mutationKey = ['getPagedWorkingTimeBookings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getPagedWorkingTimeBookings>>, {data: BodyType<GetPagedWorkingTimeBookingsRequest>}> = (props) => {
          const {data} = props ?? {};

          return  getPagedWorkingTimeBookings(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetPagedWorkingTimeBookingsMutationResult = NonNullable<Awaited<ReturnType<typeof getPagedWorkingTimeBookings>>>
    export type GetPagedWorkingTimeBookingsMutationBody = BodyType<GetPagedWorkingTimeBookingsRequest>
    export type GetPagedWorkingTimeBookingsMutationError = ErrorType<unknown>

    export const useGetPagedWorkingTimeBookings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPagedWorkingTimeBookings>>, TError,{data: BodyType<GetPagedWorkingTimeBookingsRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getPagedWorkingTimeBookings>>,
        TError,
        {data: BodyType<GetPagedWorkingTimeBookingsRequest>},
        TContext
      > => {

      const mutationOptions = getGetPagedWorkingTimeBookingsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getUpdateWorkingTimeBookingStatusUrl = () => {


  

  return `/api/WorkingTimeBooking/UpdateWorkingTimeBookingStatus`
}

export const updateWorkingTimeBookingStatus = async (updateWorkingTimeBookingStatusRequest: UpdateWorkingTimeBookingStatusRequest, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getUpdateWorkingTimeBookingStatusUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateWorkingTimeBookingStatusRequest,)
  }
);}




export const getUpdateWorkingTimeBookingStatusMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorkingTimeBookingStatus>>, TError,{data: BodyType<UpdateWorkingTimeBookingStatusRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateWorkingTimeBookingStatus>>, TError,{data: BodyType<UpdateWorkingTimeBookingStatusRequest>}, TContext> => {

const mutationKey = ['updateWorkingTimeBookingStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWorkingTimeBookingStatus>>, {data: BodyType<UpdateWorkingTimeBookingStatusRequest>}> = (props) => {
          const {data} = props ?? {};

          return  updateWorkingTimeBookingStatus(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateWorkingTimeBookingStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateWorkingTimeBookingStatus>>>
    export type UpdateWorkingTimeBookingStatusMutationBody = BodyType<UpdateWorkingTimeBookingStatusRequest>
    export type UpdateWorkingTimeBookingStatusMutationError = ErrorType<unknown>

    export const useUpdateWorkingTimeBookingStatus = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorkingTimeBookingStatus>>, TError,{data: BodyType<UpdateWorkingTimeBookingStatusRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateWorkingTimeBookingStatus>>,
        TError,
        {data: BodyType<UpdateWorkingTimeBookingStatusRequest>},
        TContext
      > => {

      const mutationOptions = getUpdateWorkingTimeBookingStatusMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getCreateWorkingTimeCorrectionUrl = () => {


  

  return `/api/WorkingTimeBooking/CreateWorkingTimeCorrection`
}

export const createWorkingTimeCorrection = async (createWorkingTimeCorrectionRequest: CreateWorkingTimeCorrectionRequest, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getCreateWorkingTimeCorrectionUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createWorkingTimeCorrectionRequest,)
  }
);}




export const getCreateWorkingTimeCorrectionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorkingTimeCorrection>>, TError,{data: BodyType<CreateWorkingTimeCorrectionRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createWorkingTimeCorrection>>, TError,{data: BodyType<CreateWorkingTimeCorrectionRequest>}, TContext> => {

const mutationKey = ['createWorkingTimeCorrection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWorkingTimeCorrection>>, {data: BodyType<CreateWorkingTimeCorrectionRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createWorkingTimeCorrection(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateWorkingTimeCorrectionMutationResult = NonNullable<Awaited<ReturnType<typeof createWorkingTimeCorrection>>>
    export type CreateWorkingTimeCorrectionMutationBody = BodyType<CreateWorkingTimeCorrectionRequest>
    export type CreateWorkingTimeCorrectionMutationError = ErrorType<unknown>

    export const useCreateWorkingTimeCorrection = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorkingTimeCorrection>>, TError,{data: BodyType<CreateWorkingTimeCorrectionRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createWorkingTimeCorrection>>,
        TError,
        {data: BodyType<CreateWorkingTimeCorrectionRequest>},
        TContext
      > => {

      const mutationOptions = getCreateWorkingTimeCorrectionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    